"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function UrbanEliteLifeVision() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="111328" id="專業居家醫護首選" className="dark bg-background text-foreground relative min-h-screen flex items-center justify-center overflow-hidden">
      
      <div className="absolute inset-0 z-0 overflow-hidden">
        <img src="https://wanted-kite.10web.cloud/wp-content/uploads/2026/03/Image-1-3.png" alt="Professional Healthcare Background" className="w-full h-full object-cover animate-fade-in animate-slow-zoom" />
      </div>

      
      <div ref={ref} className={`relative z-10 w-full max-w-[900px] mx-auto px-6 md:px-8 text-center flex flex-col items-center gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h1 className="font-heading text-5xl md:text-7xl font-bold leading-tight tracking-widest text-white uppercase drop-shadow-[0_2px_2px_rgba(0,0,0,0.8)] drop-shadow-[0_10px_30px_rgba(168,85,247,0.5)]">專業居家醫護首選</h1>
        
        <p className="font-hero text-lg md:text-xl bg-clip-text text-transparent bg-gradient-to-r from-white/90 via-white to-white/90 max-w-2xl font-light tracking-wide drop-shadow-xl">憬於未來，芯繫健康。我們由資深護理團隊領導，將專業照護帶到家中，讓每一位服務使用者都能在熟悉的環境中得到適切的治療。</p>
        
        <div className="flex flex-col sm:flex-row gap-6 mt-8 w-full sm:w-auto">
          <Link to="/NursingServicesPage" className="w-full sm:w-auto">
            <Button size="lg" className="w-full rounded-full bg-primary text-primary-foreground hover:bg-primary/90 px-10 py-7 text-sm tracking-widest uppercase transition-colors duration-300 shadow-xl">
              查看服務
            </Button>
          </Link>
          <Link to="/AboutUsPage" className="w-full sm:w-auto">
            <Button variant="outline" size="lg" className="w-full rounded-full border-foreground/30 text-foreground hover:bg-foreground/10 hover:border-foreground/50 px-10 py-7 text-sm tracking-widest uppercase transition-all duration-300 backdrop-blur-md">
              了解更多
            </Button>
          </Link>
        </div>
      </div>

      
      <style dangerouslySetInnerHTML={{
      __html: `
          :root {
            
            --font-sans: "Public Sans", "Noto Sans TC", sans-serif;
            
            --font-serif: "Playfair Display", "Noto Serif TC", serif;
            
            --font-heading: "Plus Jakarta Sans", "Noto Sans TC", sans-serif;
            
            --font-hero: "Playfair Display", "Noto Serif TC", serif;
          }

          .dark {
            
            --font-sans: "Public Sans", "Noto Sans TC", sans-serif;
            --font-serif: "Playfair Display", "Noto Serif TC", serif;
            --font-heading: "Plus Jakarta Sans", "Noto Sans TC", sans-serif;
            --font-hero: "Playfair Display", "Noto Serif TC", serif;
          }

          @keyframes fade-in {
            0% { opacity: 0; }
            100% { opacity: 1; }
          }
          .animate-fade-in {
            animation: fade-in 2s ease-out forwards;
          }

          @keyframes slow-zoom {
            0% { transform: scale(1); }
            100% { transform: scale(1.15); }
          }
          .animate-slow-zoom {
            animation: slow-zoom 25s ease-in-out infinite alternate;
          }
        `
    }} />
    </section>;
}